// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106094: шахматка — вид слайда, центрирование, группы без фона) (p051)
// «Slide look» шахматки (AttrCrossGrid): кнопка-переключатель в быстрой панели ⚙ вложенного грида (рядом с «Заголовки» / «Сортування» / «Закріплення»), настройка вида —
// viewParams.<шахматка>.slide_look (как прочие кнопки панели; запись при переключении НЕ помечается изменённой — как выбор поля «Показувати ▾», cg2SetField).
// Кнопка есть только у шахматки с cell_look. Умолчание: cell_look.toggle (если бэк отдаёт булево), иначе true. Выкл — обычная сетка: значения как есть (флажки, текст),
// стандартные заголовки, без блоков и классов cell_look. Ключи бэка align / plain_groups / toggle (PR #499) читаются с умолчаниями — без них ничего не падает.
// Чистая логика (без Vue, DOM и стора). Юнит-тест: node --test tests/unit/crossGridSlide.test.mjs
const isObj = (v) => !!v && typeof v === 'object' && !Array.isArray(v)

export const CG_SLIDE_PARAM = 'slide_look'
// ячейка в редакторе (wijmo input.wj-grid-editor, список, текст) — блок не рисуется; флажок ячейки (input.wj-cell-check) редактором не считается: в виде слайда его нет
export const CG_SLIDE_EDITOR_SEL = 'input:not(.wj-cell-check), textarea, select'

// cgSlideRaw: сырой cell_look объявления (ключ атрибута; запасной — attr.params.cell_look) или null — как cgLook (crossGridLook.js)
export function cgSlideRaw(attr) {
    const a = isObj(attr) ? attr : {}
    return isObj(a.cell_look) ? a.cell_look : (isObj(a.params) && isObj(a.params.cell_look) ? a.params.cell_look : null)
}
// cgSlide(attr, saved) → { has, def, on, align, plainGroups }: has — у шахматки есть cell_look (кнопка нужна); def — умолчание кнопки; on — вид слайда включён
// (saved — значение настройки вида: булево главнее умолчания, прочее — умолчание); align 'center' | ''; plainGroups — строки-группы без серого фона
export function cgSlide(attr, saved) {
    const raw = cgSlideRaw(attr)
    if (!raw) return { has: false, def: false, on: false, align: '', plainGroups: false }
    const def = typeof raw.toggle === 'boolean' ? raw.toggle : true
    const on = typeof saved === 'boolean' ? saved : def
    const align = typeof raw.align === 'string' && raw.align.trim().toLowerCase() === 'center' ? 'center' : ''
    return { has: true, def, on, align, plainGroups: raw.plain_groups === true }
}
// cgSlideClasses: классы прослойки вида (.cg-look) — только при включённом виде слайда
export function cgSlideClasses(slide) {
    if (!slide || !slide.on) return []
    const out = []
    if (slide.align === 'center') out.push('cg-center')
    if (slide.plainGroups) out.push('cg-pgroups')
    return out
}
// cgSlideCommand: кнопка быстрой панели ⚙ (формат commandPanel_topLeft AttrGrid: set_viewParam, нажата при value === checkValue; не сохранено — defaultValue)
export function cgSlideCommand(name, def, t) {
    const tt = typeof t === 'function' ? t : (s) => s
    return { 'binding': `doc.viewParams.${name}.${CG_SLIDE_PARAM}`, checkValue: true, default: false, defaultValue: def !== false, 'showCommandTitle': true, 'title': tt('Slide look'),
        command: 'set_viewParam', 'cssClass': 'pi p-button-white p-button-border mr-1', uiHelp: 'grid.viewParams.slideLook' }
}
// cgSlideRow: ряд панели ⚙ для вложенного грида шахматки (gridAttr.cg_matrix + cg_slide_default) — [[кнопка]]; иначе — [] (прочие гриды без изменений)
export function cgSlideRow(attr, t) {
    if (!isObj(attr) || !attr.cg_matrix || typeof attr.cg_slide_default !== 'boolean') return []
    return [[cgSlideCommand(attr.name, attr.cg_slide_default, t)]]
}
// IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106094, #106097: шахматка — вид слайда, пилюля с текстом без чекбокса) (дополнение: «сборная солянка — в части ячеек флаги, в части детализация»)
// cgSlidePill(look, o) → null | { style, text, dropCheck }: блок ячейки листа при виде слайда. look null (вид выключен / нет cell_look) или блок не нужен (o.wanted false —
// строка-группа, колонка-группа, форма не pill) — null: содержимое AttrGrid как есть (флажок, текст). Иначе в КАЖДОЙ ячейке блок стиля o.style с текстом text_binding
// (o.text); флажка нет (dropCheck) — use правится в табличной части или при выключенном виде. Пустой text_binding — блок без текста; показано не основное поле-флажок
// (выбор «Показувати ▾») — «✓» у true, чтобы значение не терялось без флажка
export function cgSlidePill(look, o) {
    if (!look || !isObj(o) || !o.wanted) return null
    const txt = typeof o.text === 'string' ? o.text : ''
    const text = txt || (o.kind === 'bool' && !o.isDefault && o.value === true ? '✓' : '')
    return { style: o.style || '', text, dropCheck: true }
}
// cgSlideBoolLocked: флажок в ячейке-блоке вида слайда не переключается (мышью — нечем, Space — отменяется в beginningEdit): флажок не виден, правка — в табличной части
export function cgSlideBoolLocked(look, kind, wanted) {
    return !!look && kind === 'bool' && !!wanted
}

// ---------- IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106094, #106318: «Slide look» — и в форме вида ⚙, рядом с «Заголовки / Сортування / Закріплення») (p051b) ----------
// Клик по ⚙ грида открывает ФОРМУ ВИДА (widget-row-viewParams «View _doc.<грид>»); её вкладка параметров — AttrTabGrid бэка 'grid-settings-<имя>' (common_modules/widgets.py:
// Панель / Заголовки / Додатковий заголовок колонок: Сортування, Закріплення … ). Быстрая панель ⚙ (AttrGrid commandPanel_topLeft — там кнопка p051) видна только при наведении
// на ⚙ (700 мс) и закрывается кликом. У шахматки с cell_look в форму вида добавляется поле «Slide look» (AttrBool slide_look) сразу после «Заголовки». Значение читает и пишет
// штатный путь формы вида (mainStore attr_get / attr_set: get_vueObj(<шахматка>) — обёртка AttrCrossGrid: запись → set_viewParam → setSlide; чтение — store.get_viewParam,
// не сохранено — defaultValue = умолчание кнопки).
export const CG_SLIDE_FORM_PREFIX = 'grid-settings-'
export function cgSlideFormField(def, t) {
    const tt = typeof t === 'function' ? t : (s) => s
    return { attr_type: 'AttrBool', binding: CG_SLIDE_PARAM, name: CG_SLIDE_PARAM, title: tt('Slide look'), defaultValue: def !== false, action_afterChange: { command: 'set_viewParam' }, uiHelp: 'grid.viewParams.slideLook', cg_slide: true }
}
// cgSlideFormFind(view, name): вкладка параметров вида грида name в дереве формы (AttrTabGrid name 'grid-settings-<name>' или binding '_doc.grid-settings-<name>'), иначе null
export function cgSlideFormFind(view, name) {
    if (!name) return null
    const want = CG_SLIDE_FORM_PREFIX + name
    const walk = (list, d) => {
        if (!Array.isArray(list) || d > 8) return null
        for (const a of list) {
            if (!isObj(a)) continue
            if (a.attr_type === 'AttrTabGrid' && (a.name === want || a.binding === '_doc.' + want)) return a
            const r = walk(a.attrs, d + 1)
            if (r) return r
        }
        return null
    }
    return walk(view, 0)
}
// cgSlideFormPlan(view, name, def, t) → null | { tab, attrs, field }: список полей вкладки с «Slide look» после «Заголовки» (headersVisibility; нет — первым); поле уже есть / вкладки нет — null
export function cgSlideFormPlan(view, name, def, t) {
    const tab = cgSlideFormFind(view, name)
    if (!tab || !Array.isArray(tab.attrs)) return null
    if (tab.attrs.some((a) => isObj(a) && a.binding === CG_SLIDE_PARAM)) return null
    const field = cgSlideFormField(def, t)
    const i = tab.attrs.findIndex((a) => isObj(a) && a.binding === 'headersVisibility')
    const attrs = tab.attrs.slice()
    attrs.splice(i >= 0 ? i + 1 : 0, 0, field)
    return { tab, attrs, field }
}
// cgSlideFormApply(store, W, name, def, t): вставить поле в открытую форму вида W (widget-row-viewParams грида name): id поля (store.prepare_attrs); вкладка смонтирована —
// её set_viewParam('attrs') (AttrTabGrid пересобирается), иначе — список полей в view. → true, если вставлено (повтор — false: поле уже есть)
export function cgSlideFormApply(store, W, name, def, t) {
    const m = W && W.record && W.record._meta
    if (!m || m.type !== 'widget-row-viewParams' || W._softClosed || W.close) return false
    const plan = cgSlideFormPlan(W.view, name, def, t)
    if (!plan) return false
    try { if (store && typeof store.prepare_attrs === 'function') store.prepare_attrs([plan.field], plan.tab.id || `cgslide${W.id}`, plan.tab.binding || '', plan.tab.attr_type) } catch (e) { /* без id — как есть */ }
    let comp = null
    try { comp = W.vueObj && typeof W.vueObj.get_vueObj === 'function' ? W.vueObj.get_vueObj(plan.tab.binding) : null } catch (e) { comp = null }
    if (comp && typeof comp.set_viewParam === 'function' && comp.attr && comp.attr.name === plan.tab.name) comp.set_viewParam('attrs', plan.attrs)
    else plan.tab.attrs = plan.attrs
    return true
}
// для проб: форма вида любого грида (на dev шахматки с cell_look нет) — window.__cgSlideFormApply(store, W, имя, умолчание)
if (typeof window !== 'undefined') window.__cgSlideFormApply = cgSlideFormApply
